import OrderFlowDeliveryPage from '../pages/flow/OrderFlowDeliveryPage'
import OrderFlowKitchenPage from '../pages/flow/OrderFlowKitchenPage'
import OrderFlowOvenPage from '../pages/flow/OrderFlowOvenPage'
import OrderFlowPage from '../pages/flow/OrderFlowPage'
import OrderFlowSalonPage from '../pages/flow/OrderFlowSalonPage'
import OrderFlowWaiterPage from '../pages/flow/OrderFlowWaiterPage'
import OrderFlowAllPage from '../pages/flow/OrderFlowAllPage'


const routes = [
    {
        name: 'OrderFlowAllPage',
        path: '/flow/all',
        component: OrderFlowAllPage,
        permission: "ORDER_SHOW_BAR"
    },
    {
        name: 'OrderFlowPage',
        path: '/flow/bar',
        component: OrderFlowPage,
        permission: "ORDER_SHOW_BAR"
    },
    {
        name: 'OrderFlowKitchenPage',
        path: '/flow/kitchen',
        component: OrderFlowKitchenPage,
        permission: "ORDER_SHOW_KITCHEN"
    },
    {
        name: 'OrderFlowOvenPage',
        path: '/flow/oven',
        component: OrderFlowOvenPage,
        permission: "ORDER_SHOW_OVEN"
    },
    {
        name: 'OrderFlowDeliveryPage',
        path: '/flow/delivery',
        component: OrderFlowDeliveryPage,
        permission: "ORDER_SHOW_DELIVERY"
    },
    {
        name: 'OrderFlowSalonPage',
        path: '/flow/salon',
        component: OrderFlowSalonPage,
        permission: "ORDER_SHOW_SALON" // TODO Hacer el permiso para salon
    },
    {
        name: 'OrderFlowWaiterPage',
        path: '/flow/waiter',
        component: OrderFlowWaiterPage,
        permission: "ORDER_SHOW_WAITER" // TODO Hacer el permiso para salon
    }

]

export default routes;
